var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        {
          attrs: {
            color: _vm.editMode ? "yellow darken-3" : "green",
            flat: "",
            dense: "",
            dark: "",
            rounded: ""
          }
        },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.editMode ? "Update Details" : "Add Details"))
          ])
        ]
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("create-voucher-details", {
                attrs: { "default-data": _vm.editVoucherDetail },
                on: {
                  "update:defaultData": function($event) {
                    _vm.editVoucherDetail = $event
                  },
                  "update:default-data": function($event) {
                    _vm.editVoucherDetail = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "9" } },
            [
              _c("table-voucher-details", {
                attrs: { edit: _vm.editVoucherDetail },
                on: {
                  "update:edit": function($event) {
                    _vm.editVoucherDetail = $event
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }